import _webUrlSearchParams from "../modules/web.url-search-params.constructor";
// TODO: Remove this module from `core-js@4` since it's replaced to module below
_webUrlSearchParams;
export default {};